<app-loading-indicator></app-loading-indicator>
<div class="container">
  <div class="row">
    <router-outlet></router-outlet>
  </div>
</div>
<footer></footer>
